var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{staticStyle:{"border":"3px solid white"}},[_c('v-img',{attrs:{"src":_vm.user.profilePic?'data:image/png;base64,'+_vm.user.profilePic.file : 'https://ui-avatars.com/api/?name='+_vm.user.firstName+'+'+_vm.user.lastName}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }